'use client';

import React, { createContext, useContext } from 'react';
import { UNDERWRITER_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';

import useTopCompany from './useTopCompanies';

type TopUnderwritersContextType = ReturnType<typeof useTopCompany>;

export const TopUnderwritersContext = createContext<TopUnderwritersContextType>(null);

export const useTopUnderwritersContext = () => {
  const context = useContext(TopUnderwritersContext);
  if (!context) {
    throw new Error('useTopUnderwritersContext must be used within the TopUnderwritersContext');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const TopUnderwritersContextProvider = ({ children }: IProps) => (
  <TopUnderwritersContext.Provider value={ useTopCompany({
    serverData: null,
    companyRole: UNDERWRITER_NAME,
  }) }
  >
    { children }
  </TopUnderwritersContext.Provider>
);

export default TopUnderwritersContextProvider;
